import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {FoundMeasurement} from "../found-measurement";
import {ApiClient} from "../../../tools/api-client";
import {recursiveNullToUndefined} from "../../../tools/recursive-null-to-undefined";

@Injectable()
export class ReturnToPreanalysisService {

  constructor(private readonly apiClient: ApiClient) {
  }

  returnToPreanalysis(measurementId: number): Observable<FoundMeasurement> {
    return this.apiClient
      .put<FoundMeasurement>(`api/measurements/${measurementId}/return-to-preanalysis`)
      .pipe(map(recursiveNullToUndefined));
  }
}
